// extracted by mini-css-extract-plugin
export default {"itemContainer":"style_itemContainer__EpQe2","account":"style_account__bVlTo","amount":"style_amount__1PukJ","time":"style_time__TNis7"};